import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TranslateServerSideModel } from '../translate-server-side-model';
import { AbstractModel } from '@patsnap/tahiti-core';
import { TaskStatus } from '@/domains/task/enums';
import { type TranslateServerSideState, TranslateStep } from '../../types';

/**
 * 翻译任务服务端状态模型实现
 */
@injectable()
export class TranslateServerSideModelImpl extends AbstractModel<TranslateServerSideState> implements TranslateServerSideModel {
    /**
     * 创建初始状态
     * @returns 初始状态
     */
    static createInitialStatus(): TranslateServerSideState {
        return {
            taskStatus: TaskStatus.READY,
            currentStep: TranslateStep.StepInitial,
            stepDetail: {},
            createdAt: '',
            updatedAt: '',
        };
    }

    protected _modelData: TranslateServerSideState = TranslateServerSideModelImpl.createInitialStatus();

    dispose(): void {
        this.update(() => {
            return TranslateServerSideModelImpl.createInitialStatus();
        });
    }
}
